import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { ButtonWrapper } from 'components/ButtonWrapper';
import { addUser } from 'store/pageSlice';

const StyledModal = styled(Modal)`
	.ant-modal-content {
		box-sizing: border-box;
		width: 612px !important;
		height: 260px;
		background: #fff;
		border: 1px solid #000;
		border-radius: 4px;
		padding: 0;
		position: relative;
		left: 0;
		top: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.ant-modal-header {
		display: none;
	}
	.ant-modal-footer {
		display: none;
	}
`;

const MessageBox = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: flex-start;
	gap: 24px;
	position: absolute;
	width: 470px;
	height: 72px;
	left: 71px;
	top: 56.5px;
`;

const MessageText = styled.span`
	width: 490px;
	height: 72px;
	font-family: 'Inter', sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 20px;
	line-height: 180%;
	text-align: center;
	color: #000;
`;

const FooterBox = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: flex-end;
	gap: 27px;
	position: absolute;
	width: 298px;
	height: 40px;
	left: 157px;
	top: 157px;
`;

export default function ReactivateTeamMemberModal({ open, onCancel, member, buId }) {
	const dispatch = useDispatch();
	const [loading, setLoading] = React.useState(false);
	if (!member) return null;
	const mapping = {
		city_manager: 'City Manager',
		supervisor: 'Supervisor',
		mis_executive: 'MIS Executive',
	};
	const handleAdd = async () => {
		setLoading(true);
		try {
			await dispatch(
				addUser({
					data: {
						update_type: 'assign_bu_user',
						data: {
							bu_id: buId,
							user_id: member.emp_id,
							role: mapping[member.role],
						},
					},
					isEditMode: true,
				})
			);
			window.location.reload();
		} finally {
			setLoading(false);
		}
	};

	return (
		<StyledModal
			open={open}
			onCancel={onCancel}
			footer={null}
			centered
			width={612}
			bodyStyle={{ padding: 0 }}
		>
			<MessageBox>
				<MessageText>
					Are you sure you want to Add{' '}
					<span style={{ textDecoration: 'underline' }}>{member.name}</span> (
					{member.role}) to the Team?
				</MessageText>
			</MessageBox>
			<FooterBox>
				<ButtonWrapper
					onClick={onCancel}
					style={{
						border: '1px solid #FF3B30',
						color: '#FF3B30',
						background: '#fff',
						borderRadius: 4,
						height: 40,
						minWidth: 135.5,
						fontSize: 16,
						fontWeight: 500,
					}}
				>
					Cancel
				</ButtonWrapper>
				<ButtonWrapper
					type="primary"
					style={{
						background: '#143E60',
						color: '#fff',
						border: 'none',
						borderRadius: 4,
						height: 40,
						minWidth: 135.5,
						fontSize: 16,
						fontWeight: 500,
					}}
					onClick={handleAdd}
					disabled={loading}
				>
					{loading ? 'Adding...' : 'Add'}
				</ButtonWrapper>
			</FooterBox>
		</StyledModal>
	);
}

ReactivateTeamMemberModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onCancel: PropTypes.func.isRequired,
	member: PropTypes.shape({
		name: PropTypes.string,
		role: PropTypes.string,
		emp_id: PropTypes.string,
	}),
	buId: PropTypes.string,
};
